import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/stores/auth';

const SUPPORTED_LOCALES = ['en', 'zh-CN'];

/**
 * 登录 / refreshUser 后，把 URL 的 locale 段同步到用户偏好（user.locale）。
 * LocaleLayout 只做「URL locale → i18n」单向同步，若登录后 URL 仍是 /en 而
 * 用户偏好 zh-CN，文案会保持英文。这里在 user 变化时重定向到偏好 locale 的
 * 对应路径（保留后续 path/search），LocaleLayout 随之切换 i18n。
 */
export function LocaleSync() {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.locale || !SUPPORTED_LOCALES.includes(user.locale)) return;
    // 跳过 auth 相关页面：登录/注册流程中 user 变化会触发本 effect，若在此切换 locale
    // 会把 /en/login → /zh-CN/login，覆盖 goAfterAuth 的跳转，导致用户停在登录页。
    // 登录后 navigate 到非 auth 页时，本 effect 自然生效（同步 URL locale 到偏好）。
    // /auth/callback（OAuth 回跳落地）同理：complete 落地时 user 变化，此处跳 locale
    // 会与落地页自身的 navigate 竞态。
    const AUTH_PATHS = ['/login', '/register', '/forgot-password', '/reset-password', '/auth/callback'];
    if (AUTH_PATHS.some((p) => location.pathname.includes(p))) return;
    const urlLocale = location.pathname.split('/')[1];
    if (urlLocale !== user.locale) {
      const rest = location.pathname.replace(/^\/[^/]+/, '');
      navigate(`/${user.locale}${rest}${location.search}`, { replace: true });
    }
  }, [user, location.pathname, location.search, navigate]);

  return null;
}
